module.exports = __webpack_public_path__ + "static/ImageTalent1-1b52da1e153d97c68fa8cbf00f44d4c0.png";